import { z } from 'zod/v3';

// UserRole DTOs
export const UserRoleDTOSchema = z.object({
  id: z.string(),
  userId: z.string(),
  roleId: z.string(),
  user: z.string(),
  role: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const UserRoleListDTOSchema = z.object({
  id: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const CreateUserRoleDTOSchema = z.object({
  userId: z.string(),
  roleId: z.string(),
  user: z.string(),
  role: z.string()
}).strict();

export const UpdateUserRoleDTOSchema = z.object({
  id: z.string(),
  userId: z.string().optional(),
  roleId: z.string().optional(),
  user: z.string().optional(),
  role: z.string().optional()
}).strict();

export type UserRoleDTO = z.infer<typeof UserRoleDTOSchema>;
export type UserRoleListDTO = z.infer<typeof UserRoleListDTOSchema>;
export type CreateUserRoleDTO = z.infer<typeof CreateUserRoleDTOSchema>;
export type UpdateUserRoleDTO = z.infer<typeof UpdateUserRoleDTOSchema>;
